import React, { LegacyRef } from "react";
import cx from "classnames";
import { Text } from "../text/Text";
import "./FieldsetInput.scss";

export interface FieldsetInputProps {
  icon?: JSX.Element;
  id: string;
  isDisabled?: boolean;
  label: string;
  name?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onIconClick?: () => void;
  placeholder?: string;
  reference?: LegacyRef<HTMLInputElement> | undefined;
  type?: React.HTMLInputTypeAttribute;
  validationMsg?: string | null | undefined;
  value?: string | number | readonly string[] | undefined;
}

export const FieldsetInput = (props: FieldsetInputProps) => {
  const {
    icon,
    id,
    isDisabled,
    label,
    name,
    onBlur,
    onChange,
    onIconClick,
    placeholder,
    reference,
    type = "text",
    validationMsg,
    value,
  } = props;

  return (
    <div className="fieldset-container">
      <fieldset
        className={cx("fieldset", {
          invalid: validationMsg,
          fieldsetWithLegend: label,
          disabled: isDisabled,
        })}
      >
        {<legend className={label ? "showLegend" : ""}>{label ? <label htmlFor={id}>{label}</label> : <></>}</legend>}
        <input
          className="input"
          data-testid={`input-${id}`}
          disabled={isDisabled}
          id={id}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          ref={reference}
          type={type ? type : "text"}
          value={value}
        />
        {icon ? (
          <button type="button" className={cx("icon-button", label && "icon-button-lower")} onClick={onIconClick}>
            {icon}
          </button>
        ) : (
          <></>
        )}
      </fieldset>
      {validationMsg ? <Text lKey={validationMsg} className="validation-message" /> : null}
    </div>
  );
};
